/** Lado maior da foto enviada (as do celular têm 4000 px ou mais; o WhatsApp reduz de qualquer jeito). */
const MAX_SIDE = 2560;

/**
 * Foto da câmera do celular: grava "deitada" com a rotação numa etiqueta (EXIF), que o navegador
 * respeita e o WhatsApp (pela Evolution) não. Aqui a foto é redesenhada já na posição certa, o que
 * também tira os metadados (inclusive a localização GPS) e reduz o tamanho. Outros arquivos e
 * qualquer falha: segue o original.
 */
export async function normalizePhoto(file: File): Promise<File> {
  if (file.type !== 'image/jpeg' || typeof createImageBitmap === 'undefined') return file;
  try {
    const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
    const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
    const width = Math.round(bitmap.width * scale);
    const height = Math.round(bitmap.height * scale);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) return file;
    ctx.drawImage(bitmap, 0, 0, width, height);
    bitmap.close();
    const blob = await new Promise<Blob | null>((ok) => canvas.toBlob(ok, 'image/jpeg', 0.88));
    return blob ? new File([blob], file.name || 'foto.jpg', { type: 'image/jpeg', lastModified: file.lastModified }) : file;
  } catch {
    return file;
  }
}
